export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0043_thumb.3e62799b.jpg";